module.exports = __webpack_public_path__ + "img/demonstration-text-item-line4.7ec53f2d.png";